import apiClient from '../apiClient';

interface visitUrlResponse {
    status_code: number;
    description_tag: string;
    size_tag: string;
    type_label_long: string;
    type_label_display: string;
    best_sizes: Array<{ label: string; size: string }>;
    friend_owns?: number;
    should_hide: boolean;
    image: string;
    gender_label: string;
}

interface unAuthVisitUrlResponse {
    status_code: number;
    description_tag: string;
    size_tag: string;
    type_label_long: string;
    type_label_display: string;
    should_hide: boolean;
    image: string;
    gender_label: string;
}

export const visitUrl = async (authToken: string, brandCode: string, currentUrl: string) => {
    try {
        const response: visitUrlResponse = await apiClient(`/widget/visit`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify({
                partner_id: brandCode,
                product_url: currentUrl,
            }),
        });

        if (response.status_code !== 200) {
            throw new Error(`Failed to visit URL for brand_code: ${brandCode} at URL: ${currentUrl}`);
        }

        // FIXME: use friend_owns
        return {
            descriptionTag: response.description_tag,
            sizeTag: response.size_tag,
            type_label_long: response.type_label_long,
            type_label_display: response.type_label_display,
            bestSizes: response.best_sizes,
            should_hide: response.should_hide,
            image: response.image,
            gender_label: response.gender_label,
        };
    } catch (error: any) {
        console.error("error in visitUrl: ", error.message);
    }
};

export const unAuthVisitUrl = async (brandCode: string, currentUrl: string) => {
    try {
        const response: unAuthVisitUrlResponse = await apiClient(`/widget/unauth_visit`, {
            method: 'POST',
            body: JSON.stringify({
                partner_id: brandCode,
                product_url: currentUrl,
            }),
        });

        if (response.status_code !== 200) {
            throw new Error(`Failed to visit URL for brand_code: ${brandCode} at URL: ${currentUrl}`);
        }

        return {
            descriptionTag: response.description_tag,
            sizeTag: response.size_tag,
            type_label_long: response.type_label_long,
            type_label_display: response.type_label_display,
            should_hide: response.should_hide,
            image: response.image,
            gender_label: response.gender_label,
        };
    } catch (error: any) {
        console.error("error in visitUrl: ", error.message);
    }
};